/**
 * ErrorBoundary — capte les erreurs React et affiche un fallback
 * plutôt qu'un écran noir.
 */
import { Component } from "react";
import { colors, fonts } from "../styles/tokens";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== "undefined" && window.console) {
      // Affichage très verbeux pour faciliter le diagnostic en production
      console.error("[ErrorBoundary] Crash capté");
      console.error("Message :", error?.message);
      console.error("Stack :", error?.stack);
      console.error("Component stack :", info?.componentStack);
      // Petit toast natif pour signaler à l'utilisateur que la page a planté
      try {
        if (typeof window.gtag === "function") {
          window.gtag("event", "exception", {
            description: error?.message || String(error),
            fatal: false,
          });
        }
      } catch { /* ignore */ }
    }
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const message =
      (this.state.error && (this.state.error.message || String(this.state.error))) ||
      "Erreur inconnue";

    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
          fontFamily: fonts.body,
          color: colors.text,
          background: colors.bg,
        }}
      >
        <div
          style={{
            maxWidth: 520,
            width: "100%",
            background: colors.card,
            border: `1px solid ${colors.border}`,
            borderRadius: 16,
            padding: 32,
            textAlign: "center",
            boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
          <h2
            style={{
              fontFamily: fonts.heading,
              fontSize: 24,
              fontWeight: 700,
              color: colors.gold,
              marginBottom: 8,
            }}
          >
            Une erreur est survenue
          </h2>
          <p style={{ color: colors.textMuted, fontSize: 14, marginBottom: 20 }}>
            La page n'a pas pu s'afficher correctement. Vous pouvez réessayer ou
            recharger l'application.
          </p>
          <pre
            style={{
              background: colors.bg,
              border: `1px solid ${colors.border}`,
              borderRadius: 8,
              padding: 12,
              fontSize: 12,
              color: colors.rose,
              textAlign: "left",
              overflow: "auto",
              maxHeight: 120,
              marginBottom: 20,
            }}
          >
            {message}
          </pre>
          <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={this.reset}
              style={{
                background: colors.gold,
                color: "#050709",
                border: "none",
                borderRadius: 10,
                padding: "10px 18px",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: fonts.body,
              }}
            >
              Réessayer
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: "transparent",
                color: colors.text,
                border: `1px solid ${colors.border}`,
                borderRadius: 10,
                padding: "10px 18px",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: fonts.body,
              }}
            >
              Recharger la page
            </button>
          </div>
        </div>
      </div>
    );
  }
}
